<sw-modal
    :title="modalTitle"
    @modal-close="onCancel"
>
    <sw-text-field
        v-model="entity.name"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelName')"
    ></sw-text-field>

    <sw-text-field
        v-model="entity.url"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelUrl')"
        :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.helpUrl')"
    ></sw-text-field>

    <sw-text-field
        v-model="entity.jsonPath"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelJsonPath')"
        :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.helpJsonPath')"
    ></sw-text-field>

    <sw-text-field
        v-model="entity.language"
        required
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelLanguage')"
        :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.helpLanguage')"
    ></sw-text-field>

    <sw-switch-field
        v-model:value="entity.active"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelActive')"
    ></sw-switch-field>

    <sw-number-field
        v-model:value="entity.position"
        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.labelPosition')"
    ></sw-number-field>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>